import React, {useState, useEffect} from 'react'
import {
    SortableContainer,
    SortableElement,
    arrayMove
} from "react-sortable-hoc";
import { SeriesStoryItemContainer, SeriesStoryItemContent } from './StorySeriesManager.styled';

const SortableStoryItem = SortableElement(({ story }) => (
    <SeriesStoryItemContainer>
        <p
            style={{
                width: "30px",
                fontWeight: "bold",
                color: "#555"
            }}
        >
            {story.original_order}.
        </p>
        <SeriesStoryItemContent>
            <div><strong>{story.name}</strong></div>
            <div style={{ fontSize: "12px", color: "#666" }}>
                {story.author_name}
            </div>
        </SeriesStoryItemContent>
    </SeriesStoryItemContainer>
));

const SortableStoryList = SortableContainer(({ stories }) => {
    return (
        <div>
            {stories.map((story, index) => (
                <SortableStoryItem
                    key={`item-${story.id}`}
                    index={index}
                    story={story}
                />
            ))}
        </div>
    );
});

const SeriesStoryReorder = ({seriesStories, onOrderChange})=>{
    const [stories, setStories] = useState(seriesStories || [])

    useEffect(() => {
        if (seriesStories && seriesStories.length > 0) {
            var withOriginalOrder = seriesStories.map(function (story, index) {
                return {
                    ...story,
                    original_order: index + 1
                };
            });

            setStories(withOriginalOrder);
        } else {
            setStories([]);
        }
    }, [seriesStories]);


    const onSortEnd = ({ oldIndex, newIndex }) => {
        if (oldIndex === newIndex) {
            return;
        }

        const newStoriesOrder = arrayMove(
            stories,
            oldIndex,
            newIndex
        );

        setStories(newStoriesOrder)
        onOrderChange(newStoriesOrder)
    }

    if (!stories || stories.length === 0) {
        return <p>No Stories available.</p>;
    }

    return(
        <SortableStoryList
            stories={stories}
            onSortEnd={onSortEnd}
            useDragHandle={false}
            helperClass="dragging-story"
        />
    )
}

export default SeriesStoryReorder
